module.exports = __webpack_public_path__ + "img/Festiral1.6494fcc9.png";